import PropTypes from 'prop-types';

const formatCurrency = (value) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
  }).format(Number(value || 0));

export default function MinutaHeader({
  minuta,
  onAbrir,
  onCerrar,
  showAbrir = false,
  showCerrar = false,
}) {
  return (
    <div className="rounded-2xl border border-[rgba(var(--border),0.7)] bg-[rgba(var(--panel),0.85)] p-4 shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="text-xs font-semibold uppercase text-[rgba(var(--muted),0.8)]">N Minuta</p>
            <p className="mt-1 text-base font-semibold text-[rgb(var(--fg))]">{minuta?.id || '—'}</p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase text-[rgba(var(--muted),0.8)]">Sucursal</p>
            <p className="mt-1 text-base font-semibold text-[rgb(var(--fg))]">
              {minuta?.sucursal_id || '—'}
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase text-[rgba(var(--muted),0.8)]">Estado</p>
            <span className="mt-1 inline-flex items-center rounded-full bg-[rgba(var(--accent),0.15)] px-3 py-1 text-xs font-semibold uppercase text-[rgb(var(--accent))]">
              {minuta?.estado || '—'}
            </span>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase text-[rgba(var(--muted),0.8)]">Total recaudado</p>
            <p className="mt-1 text-base font-semibold text-[rgb(var(--fg))]">
              {formatCurrency(minuta?.total_recaudado)}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          {showAbrir ? (
            <button
              type="button"
              onClick={onAbrir}
              className="rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-sm font-semibold text-white shadow hover:opacity-90"
            >
              Abrir minuta
            </button>
          ) : null}
          {showCerrar ? (
            <button
              type="button"
              onClick={onCerrar}
              className="rounded-xl border border-[rgba(var(--border),0.7)] px-4 py-2 text-sm font-semibold text-[rgb(var(--fg))] hover:bg-[rgba(var(--muted),0.2)]"
            >
              Cerrar minuta
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

MinutaHeader.propTypes = {
  minuta: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sucursal_id: PropTypes.string,
    estado: PropTypes.string,
    total_recaudado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  onAbrir: PropTypes.func,
  onCerrar: PropTypes.func,
  showAbrir: PropTypes.bool,
  showCerrar: PropTypes.bool,
};
